import { render, staticRenderFns } from "./ZyroLabel.vue?vue&type=template&id=092a2cd2&scoped=true&"
import script from "./ZyroLabel.vue?vue&type=script&lang=js&"
export * from "./ZyroLabel.vue?vue&type=script&lang=js&"
import style0 from "./ZyroLabel.vue?vue&type=style&index=0&id=092a2cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092a2cd2",
  null
  
)

export default component.exports